var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { deleteManyQuery, deleteQuery, localStorage } from '../utils';
var leadDataParamsKeys = {
    utm_content: 'utmContent',
    utm_campaign: 'utmCampaign',
    utm_source: 'utmSource',
    utm_term: 'utmTerm',
    gclid: 'gclid',
};
var saveLeadParams = function (router, shouldDeleteUtm) {
    if (shouldDeleteUtm === void 0) { shouldDeleteUtm = true; }
    var _a = router.query, ssgParams = _a.ssgParams, rest = __rest(_a, ["ssgParams"]);
    var leadParamsToSave = __assign(__assign({}, leadDataParamsKeys), { quiz: 'quiz' });
    var queries = Object.entries(rest).filter(function (_a) {
        var key = _a[0];
        return key in leadParamsToSave;
    });
    if (typeof window !== 'undefined' && (queries === null || queries === void 0 ? void 0 : queries.length)) {
        queries.forEach(function (_a) {
            var key = _a[0], value = _a[1];
            return localStorage.setItem(key, value);
        });
        if (shouldDeleteUtm) {
            deleteManyQuery(router, queries.map(function (_a) {
                var key = _a[0];
                return key;
            }));
            return;
        }
        deleteQuery(router, 'quiz');
    }
};
var getLeadData = function () {
    var leadData = {};
    Object.entries(leadDataParamsKeys).forEach(function (_a) {
        var key = _a[0], name = _a[1];
        var param = localStorage.getItem(key);
        if (param)
            leadData[name] = param;
    });
    var quiz = localStorage.getItem('quiz');
    if (quiz) {
        var parsedData = JSON.parse(quiz);
        leadData = __assign(__assign({}, leadData), { integrations: __spreadArray(__spreadArray([], parsedData === null || parsedData === void 0 ? void 0 : parsedData.crmPlatforms, true), [parsedData === null || parsedData === void 0 ? void 0 : parsedData.otherCrmPlatforms], false).join(','), locationsCount: parsedData === null || parsedData === void 0 ? void 0 : parsedData.locationsCount, reviewPlatforms: __spreadArray(__spreadArray([], parsedData === null || parsedData === void 0 ? void 0 : parsedData.reviewPlatforms, true), [parsedData === null || parsedData === void 0 ? void 0 : parsedData.otherReviewPlatforms], false).join(','), monthlyCustomers: parsedData === null || parsedData === void 0 ? void 0 : parsedData.monthlyCustomers, reviewManagers: parsedData === null || parsedData === void 0 ? void 0 : parsedData.otherReviewManagers, interestedSolutions: __spreadArray(__spreadArray([], parsedData === null || parsedData === void 0 ? void 0 : parsedData.interestedSolutions, true), [
                parsedData === null || parsedData === void 0 ? void 0 : parsedData.otherInterestedSolutions,
            ], false).join(',') });
    }
    var dataWithoutEmptyValues = Object.fromEntries(Object.entries(leadData).filter(function (_a) {
        var _key = _a[0], value = _a[1];
        return value !== undefined && value !== null && value !== '';
    }));
    return dataWithoutEmptyValues;
};
export { leadDataParamsKeys, getLeadData, saveLeadParams };
//# sourceMappingURL=leadHelpers.js.map